import { defineStore } from "pinia"
import { computed, ref } from "vue"

function getYesterdayRange(): [Date, Date] {
  const end = new Date()
  end.setHours(23, 59, 59, 999)
  end.setDate(end.getDate() - 1)
  const start = new Date(end)
  start.setHours(0, 0, 0, 0)
  return [start, end]
}

function formatDate(d: Date): string {
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, "0")
  const day = String(d.getDate()).padStart(2, "0")
  return `${y}-${m}-${day}`
}

export const useChainScopeStore = defineStore("chain-scope", () => {
  const selectedStoreIds = ref<string[]>([])
  const timeRange = ref<[Date, Date]>(getYesterdayRange())
  const area = ref<string | null>(null)

  const hasScopeFilter = computed(
    () => selectedStoreIds.value.length > 0 || !!area.value,
  )

  const scopeDescription = computed(() => {
    const dateStr = formatDate(timeRange.value[0])
    if (selectedStoreIds.value.length > 0)
      return `${dateStr} · 已选 ${selectedStoreIds.value.length} 家门店`
    if (area.value) return `${dateStr} · ${area.value}区`
    return `${dateStr} · 全部门店`
  })

  function setSelectedStores(ids: string[]) {
    selectedStoreIds.value = [...ids]
  }

  function setArea(value: string | null) {
    area.value = value
  }

  function setTimeRange(range: [Date, Date]) {
    timeRange.value = [range[0], range[1]]
  }

  function resetToYesterday() {
    timeRange.value = getYesterdayRange()
  }

  function reset() {
    selectedStoreIds.value = []
    area.value = null
    resetToYesterday()
  }

  return {
    selectedStoreIds,
    timeRange,
    area,
    hasScopeFilter,
    scopeDescription,
    setSelectedStores,
    setArea,
    setTimeRange,
    resetToYesterday,
    reset,
  }
})
